import { useNavigate } from 'react-router-dom';
import { useRegisterGroup } from '../api/register-group';
import { RegisterGroupForm } from '../component/register-group-form';
import { paths } from '@/config/paths';
import { track } from "@/lib/meta-pixel";
import { useQueryParams } from '@/hooks/shared/use-query-params';
import { useOnboardingPrefsStore } from '../stores/onboarding-prefs.store';

const SUBTITLE = '3 snabba steg · ca 5 min · BankID krävs för utbetalning';

// Same ranges as the create sale form's sliders
const PARTICIPANT_RANGE = [5, 50] as const;
const ITEMS_PER_PARTICIPANT_RANGE = [1, 40] as const;

/** A number from the website's profit calculator link, or undefined when missing or invalid. */
const parseCalculatorParam = (value: string, [min, max]: readonly [number, number]) => {
  const number = Number.parseInt(value, 10);
  return Number.isNaN(number) ? undefined : Math.min(max, Math.max(min, number));
};

export function RegisterGroup() {
  const navigate = useNavigate();
  const { getQueryParamByKey } = useQueryParams();
  const setPrefs = useOnboardingPrefsStore((state) => state.setPrefs);
  const mutation = useRegisterGroup();

  return (
    <div className="space-y-4 max-w-sm mx-auto px-4">
      <div className="space-y-1">
        <h2 className="text-xl font-semibold">Skapa er grupp</h2>
        <p className="text-sm text-muted-foreground">{SUBTITLE}</p>
      </div>
      <RegisterGroupForm
        onSubmit={async ({ isAdult, ...data }) => {
          const { orgId } = await mutation.mutateAsync({ data });

          setPrefs(orgId, {
            isAdult: isAdult === 'yes',
            participantCount: parseCalculatorParam(getQueryParamByKey('participants'), PARTICIPANT_RANGE),
            itemsPerParticipant: parseCalculatorParam(
              getQueryParamByKey('itemsPerParticipant'),
              ITEMS_PER_PARTICIPANT_RANGE,
            ),
          });
          track("CompleteRegistration");
          navigate(paths.group.registered.getHref(orgId));
        }}
      />
    </div>
  );
}
